import React from 'react';
import Header from './Header';
import ProductGridWithComparison from './ProductGridWithComparison';
import Footer from './Footer';
import './BoutiquePage.css';

const BoutiquePageWithComparison = () => {
  return (
    <div className="boutique-page">
      <Header />
      <main className="boutique-main">
        <div className="container">
          <div className="boutique-header">
            <h1>Boutique</h1>
            <p>Comparez et choisissez parmi notre sélection de produits</p>
          </div>
          <ProductGridWithComparison />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BoutiquePageWithComparison;
